import { COUNTRIES_PHONE_FORMAT, CountryWithPhoneFormat } from 'config';

export const formatPhoneUkr = (inputNumbers: string) => {
  const { countryCode } =
    COUNTRIES_PHONE_FORMAT[CountryWithPhoneFormat.Ukraine]!;

  let formattedInputValue = `${countryCode} `;

  if (inputNumbers.length === 1) {
    formattedInputValue = `${formattedInputValue}(${inputNumbers.substring(
      0,
      1,
    )}`;
  }
  if (inputNumbers.length >= 2) {
    formattedInputValue = `${formattedInputValue}(${inputNumbers.substring(
      3,
      5,
    )}`;
  }
  if (inputNumbers.length >= 6) {
    formattedInputValue = `${formattedInputValue}) ${inputNumbers.substring(
      5,
      8,
    )}`;
  }
  if (inputNumbers.length >= 9) {
    formattedInputValue = `${formattedInputValue}-${inputNumbers.substring(
      8,
      10,
    )}`;
  }
  if (inputNumbers.length >= 11) {
    formattedInputValue = `${formattedInputValue}-${inputNumbers.substring(
      10,
      12,
    )}`;
  }

  return formattedInputValue;
};
